(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  function initializeCollectionDirectories() {
    document.querySelectorAll('[data-collection-directory]').forEach(directory => {
      if (directory.dataset.initialized) return;
      directory.dataset.initialized = 'true';
      const filters = directory.querySelector('.collection-directory__filters');
      const groups = [...directory.querySelectorAll('[data-collection-group]')];
      filters.hidden = false;
      filters.querySelectorAll('[data-collection-filter]').forEach(button => {
        const category = button.dataset.collectionFilter;
        if (category !== 'all' && !groups.some(group => group.dataset.collectionGroup === category)) button.hidden = true;
      });
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-collection-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        groups.forEach(group => { group.hidden = button.dataset.collectionFilter !== 'all' && group.dataset.collectionGroup !== button.dataset.collectionFilter; });
      });
    });
  }
  initializeCollectionDirectories();
  document.addEventListener('shopify:section:load', initializeCollectionDirectories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
